import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../../foundations/theme.es.js";
import useIsMobile from "../../../hooks/use-is-mobile.es.js";
import { memo } from "react";
import Stack from "../../../../node_modules/@mui/material/Stack/Stack.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Typography } from "../../typography/typography.es.js";
const defaultTextStyle = {
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
function ModalBarHeaderBuilder({
  title,
  description
}) {
  const isMobile = useIsMobile();
  const titleStyle = isMobile ? theme.typography.subtitle1 : theme.typography.h6;
  const descriptionStyle = isMobile ? theme.typography.caption : theme.typography.body1;
  return /* @__PURE__ */ jsxs(Stack, { textAlign: Alignment.center, sx: defaultTextStyle, children: [
    /* @__PURE__ */ jsx(Typography, { sx: {
      ...titleStyle,
      ...defaultTextStyle
    }, children: title }),
    description ? /* @__PURE__ */ jsx(Typography, { color: "textSecondary", sx: {
      ...descriptionStyle,
      ...defaultTextStyle
    }, children: description }) : /* @__PURE__ */ jsx(Fragment, {})
  ] });
}
const ModalBarHeader = memo(ModalBarHeaderBuilder);
export {
  ModalBarHeader
};
//# sourceMappingURL=modal-header.es.js.map
